import React, { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import './WelcomeScreen.css';
import sidebarLogo from '../../simple_logo.png';

const COGNITO_DOMAIN = 'https://us-east-1tohvlurxq.auth.us-east-1.amazoncognito.com';
const COGNITO_CLIENT_ID = '2furhq1s6v5mbj77uafsr7j660';
const COGNITO_SCOPE = 'phone openid email';

// New accounts are provisioned on first login with medical data features disabled
// (see backend OrganizationService.createOrganization).
const WelcomeScreen = ({ onLogin }) => {
  const auth = useAuth();

  const handleSignup = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const redirectUri = `${process.env.REACT_APP_BASE_DOMAIN || window.location.origin}/cb`;
    const signupUrl = new URL(`${COGNITO_DOMAIN}/signup`);

    try {
      // Reuse PKCE + state from the OIDC client so the callback completes like a login
      if (auth?.userManager?.createSigninRequest) {
        const request = await auth.userManager.createSigninRequest();
        const authorizeUrl = new URL(request.url);

        for (const [key, value] of authorizeUrl.searchParams.entries()) {
          signupUrl.searchParams.set(key, value);
        }
      }
    } catch (err) {
      console.error('Error generating signup URL:', err);
    }

    // Force required params and correct redirect_uri (avoid stale localhost).
    signupUrl.searchParams.set('client_id', COGNITO_CLIENT_ID);
    signupUrl.searchParams.set('response_type', 'code');
    signupUrl.searchParams.set('scope', COGNITO_SCOPE);
    signupUrl.searchParams.set('lang', 'es');
    signupUrl.searchParams.set('redirect_uri', redirectUri);

    window.location.href = signupUrl.toString();
  }, [auth]);

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="welcome-header">
          <a
            className="welcome-login-brand-link"
            href="https://dentaris.mx"
            aria-label="Ir a dentaris.mx"
          >
            <div className="welcome-login-branding">
              <img src={sidebarLogo} alt="Dentaris" className="welcome-login-brand-image" />
              <span className="welcome-login-brand-title">Dentaris</span>
            </div>
          </a>
          <p className="welcome-subtitle">Software de Gestión Dental</p>
        </div>

        <div className="welcome-cta">
          <h2>Listo para entrar a tu clínica</h2>
          <p>Accede a tu cuenta en segundos.</p>

          <button
            className="welcome-login-btn"
            onClick={onLogin}
          >
            <i className="fas fa-sign-in-alt"></i>
            Iniciar Sesión
          </button>

          <div className="welcome-secondary-action">
            <span>¿No tienes cuenta?</span>{' '}
            <button type="button" className="welcome-signup-link" onClick={handleSignup}>
              Crear cuenta
            </button>
          </div>

          <ul className="welcome-points">
            <li className="welcome-point">
              <i className="fas fa-check"></i>
              <span>Agenda y pacientes en un solo lugar</span>
            </li>
            <li className="welcome-point">
              <i className="fas fa-check"></i>
              <span>Acceso seguro desde cualquier dispositivo</span>
            </li>
            <li className="welcome-point">
              <i className="fas fa-check"></i>
              <span>Odontograma y reportes listos</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;